<template>
  <div class="t-articles-list t-articles-list_slider">
    <swiper :options="swiperOption_article" ref="courses">
      <swiper-slide v-for="item in articles.items" :key="'article_' + item.id">
        <router-link class="t-article-item"
                     :to="{name: 'articles_view', params: {id: item.id, slug: item.slug}}">
          <p class="t-article-item__title">{{ item.title }}</p>
          <p class="t-article-item__date">{{ item.date }}</p>
        </router-link>
      </swiper-slide>
    </swiper>
    <div class="t-articles-list__pagination" :class="{'_flex-start':(articles.items.length > 5)}"></div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        data(){
            return{
                swiperOption_article: {
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    threshold: 10,
                    pagination: {
                        el: '.t-articles-list__pagination',
                        dynamicBullets: true
                    }
                }
            }
        },
        computed: {
            ...mapGetters('articles', ['articles'])
        }
    }
</script>

<style lang="sass">
@media(max-width: 769px)
  .t-articles-list
    &_slider
      margin: 0 0 24px
      .t-article-item
        width: 100%
        margin: 0
      .swiper-container
        padding-bottom: 24px
    &__pagination
      display: flex
      align-items: center
      justify-content: center
      margin: 0 auto 0
      .swiper-pagination-bullet
        margin: 0 2px
        background: $disabled
        opacity: 1
      .swiper-pagination-bullet-active
        background: $turquoise

</style>


// WEBPACK FOOTER //
// src/vue_components/ArticlesSlider.vue